<template>
  <div class="o-form-element" :class="error.hasError ? 'error' : ''">
    <label class="c-label" :for="inputId" slot="label">
      {{ label }}<sup v-if="required">*</sup>
    </label>

    <input
      class="c-field"
      :id="inputId"
      :placeholder="placeholder"
      :value="value"
      @input="updateSelf($event.target.value)"
      v-if="type === 'string'"
      :readonly="readonly"
    />
    <select
      class="c-field"
      :id="inputId"
      v-if="type === 'dropdown'"
      @input="updateSelf($event.target.value)"
    >
      <option
        v-for="option in this.options"
        :key="option.value"
        :value="option.value"
        :selected="value == option.value"
        >{{ option.text }}
      </option>
    </select>
    <input
      :id="inputId"
      :placeholder="placeholder"
      :class="'c-field'"
      v-if="type === 'number'"
      type="number"
    />
    <input
      v-if="type === 'checkbox'"
      type="checkbox"
      :id="inputId"
      :checked="value"
      value="1"
      @input="updateSelf($event.target.checked)"
      style="display: inline-block; min-height: auto; padding: 0;"
    />
    <input
      :id="inputId"
      :placeholder="placeholder"
      class="c-field"
      type="date"
      max="9999-12-31"
      @input="updateSelf($event.target.value)"
      :value="value ? value.toString().slice(0, 10) : ''"
      v-if="type === 'date'"
    />
    <div class="o-dateRange" v-if="type === 'daterange'">
      <input
        ref="dateRangeStart"
        :id="inputId"
        :placeholder="placeholder"
        class="c-field"
        type="date"
        max="9999-12-31"
        :value="value && value.start ? value.start.toString().slice(0, 10) : ''"
        @input="updateDateRange()"
      />
      <input
        ref="dateRangeEnd"
        :placeholder="placeholder"
        class="c-field"
        type="date"
        max="9999-12-31"
        :value="value && value.end ? value.end.toString().slice(0, 10) : ''"
        @input="updateDateRange()"
      />
    </div>
    <div v-if="type === 'bitMaskCheckboxes'" class="bitMaskCheckboxes">
      <div v-for="option in this.options" :key="option.value">
        <label
          ><input
            type="checkbox"
            ref="bitMaskInput"
            :value="option.value"
            :checked="(value & option.value) > 0"
            @input="updateBitMaskValue"
          />{{ option.text }}</label
        ><br />
      </div>
    </div>
    <div v-if="type === 'radios'" class="radios">
      <div v-for="option in this.options" :key="option.value">
        <label
          ><input
            type="radio"
            ref="radioInput"
            :value="option.value"
            :checked="value === option.value"
            :name="label"
            @input="updateRadioValue"
          />{{ option.text }}</label
        ><br />
      </div>
    </div>
    <div v-if="type === 'wysiwyg'">
      <froala :id="inputId" tag="textarea" :config="config" :value="content" />
    </div>

    <slot></slot>
    <div class="c-errormessage">
      {{ error.errorText }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'BosInput',
  methods: {
    updateDateRange() {
      this.$emit('input', {
        start: this.$refs.dateRangeStart.value,
        end: this.$refs.dateRangeEnd.value
      })
    },
    updateSelf(val) {
      this.$emit('input', val)
    },
    updateBitMaskValue() {
      let retVal = 0
      for (let idx in this.$refs.bitMaskInput) {
        if (this.$refs.bitMaskInput[idx].checked) {
          retVal += parseInt(this.$refs.bitMaskInput[idx].value)
        }
      }
      this.updateSelf(retVal)
    },
    updateRadioValue() {
      for (let idx in this.$refs.radioInput) {
        if (this.$refs.radioInput[idx].checked) {
          this.updateSelf(this.$refs.radioInput[idx].value)
          return
        }
      }
      this.updateSelf(null)
    }
  },
  computed: {
    inputId() {
      return (
        this.id +
        '_' +
        Math.random()
          .toString(36)
          .substr(2, 9)
      )
    },
    content() {
      return this.$props.value
    }
  },
  props: {
    id: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: true,
      default: 'Label'
    },
    type: {
      type: String,
      default: 'string'
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function() {
        return []
      }
    },
    model: {
      type: Object,
      default: function() {
        return {}
      }
    },
    error: {
      Object,
      default: function() {
        return {
          hasError: false
        }
      }
    },
    value: {}
  },
  data() {
    let self = this
    return {
      config: {
        events: {
          blur: function() {
            self.$emit('input', this.html.get())
          }
        },
        attribution: false,
        quickInsertTags: [],
        placeholderText: '...',
        charCounterCount: false,
        key: process.env.VUE_APP_FROALA_LICENCE_KEY, // 'te1C2sE6D7B4C5F4D4jgwknzpC2I-8zrogB-11tjH4dj1uD3E2D1C1C4G1E4F1A10D9==',
        toolbarButtons: [
          'fontsize',
          '|',
          'bold',
          'italic',
          'formatOL',
          'formatUL',
          'link',
          'insertTable'
        ]
      }
    }
  },
  mounted() {
    this.$emit('setOptions', this.options)
  }
}
</script>

<style lang="scss" scoped>
.c-label {
  font-weight: 600;
}

.error .c-label {
  color: red;
}

.o-dateRange {
  display: flex;

  input {
    &:first-of-type {
      margin-right: 4px;
    }

    &:last-of-type {
      margin-left: 4px;
    }
  }
}

.c-errormessage {
  margin-top: 10px;
  color: red;
  display: none;
}

.o-form-element {
  input {
    min-height: 42px;
  }

  .bitMaskCheckboxes, .radios {
    input {
      min-height: initial;
    }
  }

  &.error {
    input {
      color: red;
      border-color: red;
    }

    .c-errormessage {
      display: block;
    }
  }
}

.a-editable {
  outline: none;
  border-bottom-left-radius: var(--border-radius);
  border-bottom-right-radius: var(--border-radius);
  border: var(--border-width) var(--border-style) var(--border-color);
}

.a-editable__menu {
  background-color: #f6f6f6;
  border-top: 1px solid rgba(0, 0, 0, 0.4);
  border-left: 1px solid rgba(0, 0, 0, 0.4);
  border-right: 1px solid rgba(0, 0, 0, 0.4);

  button {
    background-color: transparent;
    border: none;
    border-right: 1px solid rgba(0, 0, 0, 0.3);
    padding: 0.333rem;
    min-width: 2rem;
  }
}
</style>
<style lang="css">
.ck.ck-content .table {
  margin: 1em 0;
}
</style>
<style lang="scss">
.ProseMirror {
  padding: 24px;

  &:focus {
    outline: none !important;
  }
}
</style>
